<template>
  <div>
    <!-- eslint-disable vue/no-mutating-props -->
    <AppLazySelect
      v-model="selected"
      eager
      multiple
      class="member-filter"
      resource="member"
      label="Members"
      :fetcher="fetcher"
    >
      <template #item-leading="{ item: user }">
        <AppAvatar
          v-if="user.avatar"
          :avatar="user.avatar"
          size="speck"
        />
      </template>

      <template #item-trailing="{ item: user }">
        <span v-if="user.removed">Removed</span>
      </template>
    </AppLazySelect>
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { mapGetters } from 'vuex';

import { isMobile } from '~/mixins';
import { WorkBreakPoliciesResource } from '~/resources';

export default {
  name: 'WorkBreakPoliciesMemberSelect',
  mixins: [isMobile],
  props: {
    workBreakPolicy: Object,
  },
  computed: {
    ...mapGetters(['organizationId']),
    selected: {
      get() {
        return this.workBreakPolicy.member_ids || [];
      },
      set(userIds = []) {
        this.workBreakPolicy.member_ids = userIds;
      },
    },
  },
  methods: {
    fetcher(payload) {
      const finalPayload = {
        ...payload,
        ...this.queryParams,
        filters: {
          ...(payload.filters || {}),
          ...this.filterParams,
          removed_after: this.reportStartDate,
        },
      };

      return WorkBreakPoliciesResource.members({ organization_id: this.organizationId }, finalPayload, {
        abortReload: true,
      }).then((response) => {
        const disabledIds = new Set(response.disabled_ids || []);

        return {
          ...response,
          items: response.items.map((item) => ({
            ...item,
            disabled: disabledIds.has(item.id) ? 'Add them to a project first.' : false,
          })),
        };
      });
    },
  },
};
/* eslint-enable vue/no-mutating-props */
</script>
